<template>
    <div class="page">
        <div class="main_body">
                <div class="top_label">
                    <span class="lable_name">我的收藏</span>
                </div>

                <div class="second_box">
   

                    <!-- <div class="label_button_box">
                        <div class="label_button_box_left">
                            <el-input v-model="input" placeholder="请输入学生姓?></el-input>
                            <el-button type="primary">搜索</el-button>
                        </div>
                        <div class="label_button_box_right">
                            
                            <el-button size="small" type="primary">导出成绩</el-button>
                        </div>
                        
                    </div> -->
                    <el-table
                        ref="multipleTable"
                        :data="tableData"
                        tooltip-effect="dark"
                        style="width: 100%"
                        >
                        <el-table-column
                        type="index"
                        width="55">
                        </el-table-column>
    
                        <el-table-column
                            prop="title"
                            label="标题"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="createtime"
                        label="收藏时间"
                        width="120"
                        >
                        </el-table-column>
      
                    </el-table>


                </div>

            </div>
    </div>
</template>

<script>
import Http from "../../apis/common";
export default {
    data() {
        return {
      
            tableData: []
    
        };
    },
    created(){
        this.getList();
    },

    methods: {
        getList(){
            Http.Index().then((res) => {
      
                this.tableData = res.data
            });
        },
    }
};
</script>

<style scoped>
@media screen and (min-width:320px) and (max-width:1199px) {

}
@media (min-width: 1200px) and (max-width: 1920px) {
    .label_button_box_right >>> .el-button{
        float: right;
        margin-top: 0px;
    }
    .label_button_box_left{
        float: right;
        width:21vw;
    }
}
@media (min-width: 1921px) and (max-width: 2600px) {
    .label_button_box_right >>> .el-button{
        float: right;
    }
    .label_button_box_left{
        float: right;
        width:19vw;
    }
}
.top_label{
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
    margin-bottom: 20px;
}
.lable_name{
    font-size: 18px;
    font-weight: 700;
}
.label_button_box{
    width: 100%;
    height: 2vw;
    line-height: 2vw;
    display: inline-block;
    margin-bottom: 20px;
    margin-top:20px;
}
.label_button_box_left{
    float: left;
}
.label_button_box_right{
    float: right;

}
.label_button_box_left >>> .el-input{
    float: left;
    width: 15vw;
    margin-right: 10px;
}
.second_box {
    text-align: left;
}

.second_box >>> .el-select{
    width: 25vw;
}
.second_box >>> .el-row{
 
    border: 1px solid #ebeef5;
    margin: 0 !important;
    
    margin-top: 15px !important;
    padding: 10px 0;
}
.second_box >>> .title{
 
    line-height: 30px;
 
}
.second_box >>> .number{
 
    line-height: 30px;

}
.second_p_box >>> .el-button--text{

    font-size: 18px;
}
.second_p_box{
    text-indent: 2vw;
    margin: 0 !important;
    padding: 0 !important;
}
</style>